/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { EMAProvider, EMAProvider$inboundSchema } from "./emaprovider.js";

/**
 * The EMA providers for one vendor authorization server, in the order identity chaining tries them. Each provider that can serve is tried in turn, with short bounded retries for transient failures, until one succeeds.
 */
export type EMAProviderOrder = {
  /**
   * No order is saved, so the endpoint uses its configured external issuer.
   */
  isDefault: boolean;
  /**
   * The saved providers in order, or the external default.
   */
  providers: Array<EMAProvider>;
  /**
   * The vendor authorization server issuer, canonicalized.
   */
  vendorIssuer: string;
};

/** @internal */
export const EMAProviderOrder$inboundSchema: z.ZodMiniType<
  EMAProviderOrder,
  unknown
> = z.pipe(
  z.object({
    is_default: z.boolean(),
    providers: z.array(EMAProvider$inboundSchema),
    vendor_issuer: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "is_default": "isDefault",
      "vendor_issuer": "vendorIssuer",
    });
  }),
);

export function emaProviderOrderFromJSON(
  jsonString: string,
): SafeParseResult<EMAProviderOrder, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EMAProviderOrder$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EMAProviderOrder' from JSON`,
  );
}
